<template>
  <div class="dataView-main">
    <!-- 导航栏按键 -->
    <div class="nav-icon-left nav-icon-btn">
      <img src="../../assets/img/shezhi.png" alt="" />
    </div>
    <div class="nav-icon-right nav-icon-btn">
      <img src="../../assets/img/quanping.png" alt="" />
    </div>

    <!-- 导航栏头部 -->
    <div class="nav-bg">
      <div class="nav-centent">
        <span>{{ time2 }}</span>
        <span>{{ time }}</span>
        <span>{{ time1 }}</span>
      </div>
    </div>

    <!-- 左边内容区---数量排行 -->
    <div class="User-ranking">
      <!-- 组件 -->
      <p>用户数量排行</p>
      <user class="User"></user>
    </div>

    <!-- 中间内容区 -->
    <div class="content">
      <!-- 中间内容区---项目地图 -->
      <div class="Project-map">
        <!-- <router-link tag="span" to="about" style="color:red">点我</router-link> -->
        <p>项目地图</p>
        <!-- <Map></Map> -->
      </div>
    </div>

    <!-- 右边内容区 -->
    <div class="right">
      <div class="age toright">
        <p>团队配置</p>
        <sex-main class="sex-style"></sex-main>
        <toagess2 class="sex-style"></toagess2>
        <responsibility class="sex-style"></responsibility>
      </div>
      <div class="scale toright">
        <p>项目耗时</p>
        <scale class="scaleStyles"></scale>
      </div>
      <div class="education toright">
        <p>项目面积</p>
        <education class="educationStyles"></education>
      </div>
    </div>
  </div>
</template>

<script>
//left 排行数据
import user from "../../components/DataView/user";
//left 企业性质
import enterprise from "../../components/DataView/enterprise";
//centent 月度新增数量
import monthly from "../../components/DataView/Monthly";
//centent 企业新增数量
import enterpriseAdd from "../../components/DataView/enterpriseAdd";
//centent 地图
import Map from "../../components/DataView/Map";
//right 性别
import sexMain from "../../components/DataView/sex";
//right 年龄
import toagess2 from "../../components/DataView/age2";
//right 专业
import responsibility from "../../components/DataView/responsibility";
//right 规模数量
import scale from "../../components/DataView/scale";
//right 用户学历/产值规模
import education from "../../components/DataView/education";
//right 员工规模
import staff from "../../components/DataView/staff";

export default {
  name: "userBigData",
  components: {
    user,
    monthly,
    sexMain,
    toagess2,
    responsibility,
    scale,
    education,
    Map
  },
  data() {
    return {
      time: "BIM云平台户大数据",
      time1: "35℃ 多云 南风 上海",
      time2: "2019/07/23 17：50 星期二"
    };
  }
};
</script>

<style lang="scss" scoped>
.nav-icon-btn {
  top: 23px;
  position: absolute;
  width: 30px;
  height: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
.nav-icon-left {
  left: 10px;
}
.nav-icon-right {
  right: 14px;
}

.dataView-main {
  width: 100%;
  height: 1080px;
  position: relative;
  // overflow: hidden;
  background-color: #0d2043;
}
.nav-bg {
  width: 100%;
  height: 82px;
  background-image: url("../../assets/img/nav-bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  margin: 0 0 1% 0;
  .nav-centent {
    font-size: 1rem;
    color: aqua;
    margin-top: 1.4%;
    display: flex;
    justify-content: space-around;
    align-content: center;
    span:nth-child(2) {
      margin-top: -0.4%;
      font-weight: 700;
      font-size: 26px;
    }
  }
}
.content {
  float: left;
  width: 50%;
  height: 1080px;
  margin: 4px 20px 0 0;
  .Monthly-new,
  .Project-map {
    float: left;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/组 3.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: relative;
    margin-bottom: 10px;
    p {
      position: absolute;
      font-size: 14px;
      color: #67eeff;
      top: 8px;
      left: 10px;
    }
  }
  .monthly-style {
    // margin-top: 64px;
    width: 100%;
    height: 100%;
  }
  .Project-map {
    height: 810px;
    background-position: 0 0;
    background-image: url("../../assets/img/组 3.png");
  }
}
.User-ranking {
  float: left;
  width: 27%;
  height: 820px;
  // background-color: #2f4554;
  // border: 1px solid #1e4968;
  background-image: url("../../assets/img/user-left.png");
  background-size: 97%;
  background-repeat: no-repeat;
  margin: 0 0 0 26px;
  position: relative;
  .User {
    width: 100%;
    height: 100%;
  }
  p {
    position: absolute;
    font-size: 14px;
    color: #67eeff;
    top: 5px;
    left: 10px;
  }
}
.right {
  float: left;
  // padding: 0 36px 0;
  height: 600px;
  width: 19%;
  // background-color: darkseagreen;
  .toright {
    height: 275px;
    width: 100%;
    background-image: url("../../assets/img/age.png");
    background-size: 100%;
    background-repeat: no-repeat;
    position: relative;
    p {
      position: absolute;
      font-size: 16px;
      color: #67eeff;
      top: 3px;
      left: 10px;
    }
  }
}
.age {
  display: flex;
  justify-content: space-around;
  align-content: center;
  position: relative;
  .sex-style {
    width: 100%;
    height: 100%;
  }
}
.scaleStyles,
.educationStyles {
  width: 90%;
  height: 90%;
  margin-left: 10px;
}
</style>
